<h2>Home</h2>
<div class="card">
  <div class="input-icon">
    <input
      type="text"
      class="form-control"
      placeholder="Buscar"
      [formControl]="searchUser"
    />
    <img src="assets/svg/search.svg" alt="search" />
  </div>
  <app-table
    [tableHeader]="tableHeader"
    [list]="data"
    [actionList]="['Visualizar']"
    imgForActions="assets/img/view.png"
    (onSelectAction)="selectAction($event)"
  />

  <app-pagination
    [total]="count"
    [value]="pagination"
    [showRowsSelect]="true"
    (onPaginationChange)="onPaginationChange($event)"
  />
</div>
